import { Button, Container, Image } from 'react-bootstrap';
import { Col, Row } from 'react-bootstrap';
import BannerImage from 'assets/img/landing/defaultLandingBanner.png';
import StudentBannerImage from 'assets/img/landing/studentLandingBanner.png';
import RecruiterBannerImage from 'assets/img/landing/recruiterBanner.png';
import CollegeBannerImage from 'assets/img/landing/collegeBanner.png';
import { BannerDetail, Props } from './banner.type';
import { LandingRole } from 'pages/landing/main.type';
import { ReactNode, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BookDemoModal from 'components/modals/BookDemoModal';

const metricsData = [
  { label: 'Enterprise', value: '10k' },
  { label: 'HR Leaders', value: '200+' },
  { label: 'Colleges', value: '10+' },
  { label: 'Countries', value: '100+' }
];

const bannerDetailsMapping: Record<LandingRole, BannerDetail> = {
  student: {
    subTitle: '🚀 Build Skills. Get Certified. Land Your Dream Job.',
    description:
      'Join the tech platform to sharpen skills, earn certifications, and connect with global recruiters.',
    bannerImage: StudentBannerImage
  },
  recruiter: {
    subTitle: 'Where Innovation Meets Hiring Success!',
    description:
      'Crud Beat connects top tech talent with recruiters, enabling seamless discovery, assessment, and hiring of skilled professionals.',
    bannerImage: RecruiterBannerImage
  },
  default: {
    subTitle: 'Welcome to CRUD Beat',
    description:
      'Empower your goals with CRUD Beat connecting employers, educators, and job seekers through smarter tools for a brighter future.',
    bannerImage: BannerImage
  },
  college: {
    subTitle: 'Your Students’ Success Starts Here!',
    description:
      'Connect students with global recruiters, enhance skills via hackathons, and track progress with real-time analytics.',
    bannerImage: CollegeBannerImage
  }
};

const bannerTitleMapping: Record<LandingRole, ReactNode> = {
  student: (
    <p className="banner_left_heading text-body-highlight leading-4">
      Transform Every <span className="text-secondary-light">Interview</span>{' '}
      Into A Winning <span className="text-primary">Opportunity</span>
    </p>
  ),
  recruiter: (
    <p className="banner_left_heading text-body-highlight leading-4">
      Discover<span className="text-secondary-light">Tech</span> Talent Fast
      with Ultimate <span className="text-primary">Platform</span>
    </p>
  ),
  default: (
    <p className="banner_left_heading text-body-highlight leading-4">
      Empowering <span className="text-secondary-light">Careers</span>{' '}
      Redefining Success with{' '}
      <span className="text-secondary-light">Crud Beat.</span>
    </p>
  ),
  college: (
    <p className="banner_left_heading text-body-highlight leading-4">
      Unlock Infinite <span className="text-secondary-light">Career</span>{' '}
      Possibilities with <span className="text-primary">CRUDBeat</span>
    </p>
  )
};
const noGetStartedRequired = ['default', 'student'];
const noDemoRequired = ['student'];
const navigation: Record<LandingRole, string | null> = {
  student: null,
  recruiter: 'recruiter',
  default: null,
  college: 'institution'
};

function Banner({ role }: Props) {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const bannerDetails = bannerDetailsMapping[role];
  const isGetStarted = !noGetStartedRequired.includes(role);
  const isDemo = !noDemoRequired.includes(role);
  const currentNav = navigation[role];
  return (
    <Container fluid className="banner bg-body-highlight">
      <BookDemoModal show={show} onClose={() => setShow(false)} />
      <Row className="px-lg-9 pb-6">
        <Col lg={6} className="pt-10 banner_left">
          <p className="text-body-quaternary fs-7">{bannerDetails.subTitle}</p>
          {bannerTitleMapping[role]}
          <p className="text-body-quaternary fs-7">
            {bannerDetails.description}
          </p>
          <div className="d-flex gap-4">
            {isGetStarted && (
              <Button
                variant="primary"
                className="px-6 py-3 rounded-2 mt-3 w-100 w-md-auto"
                onClick={() => navigate(`/register/${currentNav}/basic`)}
              >
                Get Started
              </Button>
            )}
            {isDemo && (
              <Button
                variant="outline-secondary"
                className="px-6 py-3 rounded-2 mt-3 w-100 w-md-auto"
                onClick={() => setShow(true)}
              >
                Request a Demo
              </Button>
            )}
          </div>
        </Col>
        <Col lg={6} className="pt-10 d-flex justify-content-end">
          <Image
            src={bannerDetails.bannerImage}
            alt="banner-image"
            width="100%"
          />
        </Col>
      </Row>
      <Row className="mx-3 bg-body p-5 rounded-4">
        <Col
          className="text-body-highlight fs-lg-5 fs-md-5 fs-6 fw-bold pe-lg-10"
          lg={4}
        >
          Global Reach and Impact Across Talent Acquisition
        </Col>
        <Col lg={8}>
          <Row>
            {metricsData.map((data, index) => (
              <Col
                md={3}
                sm={6}
                xs={6}
                key={`metrics-${index}`}
                className="d-flex flex-column justify-content-center align-items-center pt-md-4 pt-5 pt-lg-0"
              >
                <p className="m-0 fs-lg-5 fs-md-5 fs-7 fw-bold text-primary">
                  {data.value}
                </p>
                <p className="m-0 fs-lg-7 fs-md-7 fs-9 text-body-highlight">
                  {data.label}
                </p>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export default Banner;
